import { Frequency } from '../models/frequency.model';

export const mapFrequency = (trashFrequency: Frequency, recyclingFrequency: Frequency): string => {
  if (!trashFrequency || !recyclingFrequency) {
    return '';
  }
  if (trashFrequency === recyclingFrequency) {
    return `${trashFrequency} trash & recycling pickup`;
  } else {
    return `${trashFrequency} trash pickup, ${recyclingFrequency.toLowerCase()} recycling`;
  }
};
